import { IProjectRole } from "@/interfaces";
import _ from "lodash";

// This file can be removed once the template feature flag is removed
export const mapProjectRole = (role: IProjectRole): IProjectRole => {
  const { regionSpecificTemplateRoles } = role;

  return {
    ...role,
    isMilestoneEditor: false,
    regionSpecificTemplateRoles: [],
    regions: _.mapValues(
      _.groupBy(regionSpecificTemplateRoles, ({ region }) => region),
      (role) =>
        _.keyBy(role.map(({ functionalAreaIds }) => functionalAreaIds).flat())
    ),
  };
};
